// Client mirror of the server's validateName (server/utils/validation.js).
// A person's name (first / last / full) may contain letters of any language
// (accents included), spaces, hyphens, apostrophes and periods only — never digits or
// markup — so a name can't smuggle a script into anything that later renders it
// (e.g. HTML emails). Keep this in sync with the server rule.
//
// \p{L} = any Unicode letter, \p{M} = combining marks (accents). Plus space,
// straight apostrophe, curly apostrophe (’), hyphen and period.
export const NAME_REGEX = /^[\p{L}\p{M} '’.-]+$/u;
export const NAME_MAX_LENGTH = 50;
export const NAME_CHARSET_HINT =
  'Letters, spaces, hyphens, apostrophes and periods only';

// react-hook-form `validate` shape: return true when acceptable, otherwise the
// error message to display. Emptiness is deliberately left to the field's
// `required` rule so this can be composed with it.
export const validateNameValue = (value: string): true | string => {
  const trimmed = (value ?? '').trim();
  if (!trimmed) return true;
  if (trimmed.length > NAME_MAX_LENGTH)
    return `Cannot exceed ${NAME_MAX_LENGTH} characters`;
  return NAME_REGEX.test(trimmed) || NAME_CHARSET_HINT;
};
